// extracted by css-extract-rspack-plugin
var _1 = "zzprG";
var _2 = "s0NVw";
var _3 = "Ksdin";
var _4 = "i7xzh";
var _5 = "gy2XW";
export { _1 as "checkboxStylesOverride", _2 as "checkmarkStyles", _3 as "indeterminateOrCheckedStyle", _4 as "selectedMessageCheckboxStyle", _5 as "squareCheckbox" }
